// Local persistence of in-progress claim data, so a failed submission retry,
// refresh, or accidental navigation does not lose what the user typed. Only
// serialisable fields are stored — files (uploaded form, photos, docs,
// sketch) cannot be persisted and are re-attached by the user. Each draft is
// cleared on a successful submission. Storage failures (e.g. Safari private
// mode, quota) are swallowed: drafting is a convenience and must never block
// submission. Each draft is wrapped in a `{ savedAt, data }` envelope so stale
// drafts expire — important on the public, often shared-device claim page.

export const DRAFT_KEYS = {
  upload: 'apa.claim.upload.draft',
  form: 'apa.claim.form.draft',
  motorClaim: 'apa.claim.motorclaim.draft',
  // the voice journey drafts separately: it has its own screens, so restoring
  // one journey's draft into the other would drop the claimant mid-way through
  // a step that journey doesn't have
  voiceClaim: 'apa.claim.voiceclaim.draft',
  windscreen: 'apa.claim.windscreen.draft',
}

export const DRAFT_TTL_MS = 24 * 60 * 60 * 1000 // 1 day

export function saveDraft(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), data }))
  } catch {
    // storage unavailable or full — ignore
  }
}

export function loadDraft(key, { maxAgeMs = DRAFT_TTL_MS } = {}) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    // Back-compat: legacy drafts stored the payload without an envelope.
    if (
      !parsed ||
      typeof parsed !== 'object' ||
      typeof parsed.savedAt !== 'number'
    ) {
      return parsed
    }
    if (Date.now() - parsed.savedAt > maxAgeMs) {
      localStorage.removeItem(key)
      return null
    }
    return parsed.data
  } catch {
    return null
  }
}

export function clearDraft(key) {
  try {
    localStorage.removeItem(key)
  } catch {
    // ignore
  }
}
